export default __webpack_public_path__ + "static/media/weight.9bff4fb5.svg";